<section class="footer bg-dark position-relative pt-5 pb-4">
  <div
    class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"
    style="z-index: 0"
  ></div>

  <div class="container position-relative" style="z-index: 1">
    <div class="row justify-content-between">
      <div class="col-lg-4 mb-4 mb-lg-0">
        <div class="d-flex align-items-center mb-4">
          <img
            src="/assets/images/logo-asah-skill.png"
            alt="Asah Skill"
            height="50"
            class="me-3"
            style="mix-blend-mode: multiply"
          />
          <h5 class="text-white fw-bold mb-0">ASAH SKILL</h5>
        </div>

        <div class="d-flex mb-3">
          <i class="bi bi-geo-alt-fill text-primary me-3 fs-5"></i>
          <p class="text-white-50 mb-0">
            Gedung Epicentrum Walk Lantai 5, Suite 306.<br />
            Jln. H. R. Rasuna Said, Jakarta.
          </p>
        </div>

        <div class="d-flex mb-4">
          <i class="bi bi-envelope-fill text-primary me-3 fs-5"></i>
          <a
            href="mailto:cs@bisnistekno.co.id"
            class="text-white-50 text-decoration-none hover-text-white"
          >
            cs@bisnistekno.co.id
          </a>
        </div>

        <div>
          <h6 class="text-white text-uppercase small mb-3">Ikuti Kami</h6>
          <div class="d-flex gap-3" style="display: flex; gap: 1em">
            <a href="#" class="social-icon" target="_blank">
              <i class="bi bi-facebook"></i>
            </a>
            <a href="#" class="social-icon" target="_blank">
              <i class="bi bi-twitter-x"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="bi bi-instagram"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="bi bi-linkedin"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-7">
        <div class="row">
          <div class="col-md-6 mb-4 mb-md-0">
            <h6
              class="text-white text-uppercase fw-bold mb-3 border-bottom border-primary pb-2 d-inline-block"
            >
              Uji Skill
            </h6>
            <p class="text-white-50 small mb-3">
              Platform evaluasi kompetensi independen. Ukur kemampuan teknis
              Anda melalui serangkaian tes terstandarisasi untuk validasi
              keahlian profesional.
            </p>
            <a
              href="https://uji-skill.com"
              target="_blank"
              class="btn btn-sm btn-outline-light rounded-pill px-3"
            >
              Kunjungi Situs <i class="bi bi-arrow-up-right ms-1"></i>
            </a>
          </div>

          <div class="col-md-6">
            <h6
              class="text-white text-uppercase fw-bold mb-3 border-bottom border-primary pb-2 d-inline-block"
            >
              Bank Sertifikat
            </h6>
            <p class="text-white-50 small mb-3">
              Gerbang karir Anda. Terhubung langsung dengan peluang kerja
              eksklusif dan validasi sertifikasi keahlian yang diakui oleh
              berbagai perusahaan mitra.
            </p>
            <a
              href="https://banksertifikat.com"
              target="_blank"
              class="btn btn-sm btn-outline-light rounded-pill px-3"
            >
              Kunjungi Situs <i class="bi bi-arrow-up-right ms-1"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 pt-4 border-top border-secondary">
      <div class="col-12 text-center">
        <p class="text-white-50 small mb-0">
          &copy; {{ year }} PT Bisnis Tekno. All Rights Reserved.
        </p>
      </div>
    </div>
  </div>
</section>
